import './Minute.css';
import { useEffect, useContext, useRef } from 'react';
import { AudienceContext } from '../../../context/AudienceContext';
import { ChannelsContext } from '../../../context/ChannelsContext';
import { usePreference } from '../../../context/usePreference';
import { getUserPreferenceLocalStorage } from '../../../context/utils';
import { MinuteErrorMessage } from './MinuteErrorMessage';
import { MinuteNetWorkMessage } from './MinuteNetWorkMessage';
import { MinuteTable } from './MinuteTable';
import { NetworkAlertContext } from '../../../context/NetworkAlertContext';
import { DivMinuteEnum, SelectTypeGridEnum } from '../../../utils/enums';
import { VerificaTargetUpdate } from "../../../../src/context/utils";
import { UserPreferenceContext } from "../../../context/UserPreferenceContext";


function Minute({ onSelectGrid, selectTypeGrid, changeSelectDiv, DivMinute, DivChart }) {
  //selectTypeGrid= 0:chart | 1:minute | 2:both | 3:none
  const { lastThirtyAudiencePie,
    lastThirtyAudience,
    audience,
    audienceFirstTable,
    doAudience,
    changeBaseMinute,
    lastAudience,
    setAudience,
    setAudienceFirstTable,
    setLastAudience,
    setAudienceMedia,
    setAudienceMediaFirstTable,
    doAudienceImageEmissora } = useContext(AudienceContext);
  const { channels, doChannels } = useContext(ChannelsContext);
  const { userPreference } = useContext(UserPreferenceContext);
  const user = usePreference();
  const { showError, setShowError, infoError, showInfo, infoSpan } = useContext(NetworkAlertContext);
  const hasLoadedAtBottom = useRef(false);
  const bottomCooldown = useRef<NodeJS.Timeout | null>(null);
  const autoUpdateTimerRef = useRef<NodeJS.Timeout | null>(null);

  if (channels !== undefined)
    user.setLoaded(true);

  useEffect(() => {
    if (DivMinute === DivMinuteEnum.Minute || DivMinute === DivMinuteEnum.Media) {
      setAudienceMedia([]);
      setAudienceMediaFirstTable([]);
      setAudience([]);
      setAudienceFirstTable([]);
      setLastAudience([]);
    }

  }, [DivMinute]);

  useEffect(() => {
    const targets = userPreference?.Praca?.Targets;
    const target = userPreference?.Target;

    if (targets?.[0]?.Id === target?.Id) {
      VerificaTargetUpdate(user.userPreference);
    }
  }, []);


  useEffect(() => {
    if (DivMinute === DivMinuteEnum.Minute) {
      doChannels();
      loadAudience();
      initilizeAudienceTimer();
    }
  }, [DivMinute]);

  // Cleanup timer quando componente é desmontado
  useEffect(() => {
    return () => {
      if (autoUpdateTimerRef.current) {
        clearInterval(autoUpdateTimerRef.current);
      }
    };
  }, []);

  function loadAudience() {
    const selectTypeGridLs = localStorage.getItem("selectTypeGrid") != null ? parseInt(localStorage.getItem("selectTypeGrid")!) : selectTypeGrid;
    if (selectTypeGridLs === SelectTypeGridEnum.Minute || selectTypeGridLs === SelectTypeGridEnum.Both || selectTypeGridLs === SelectTypeGridEnum.Empty) {
      doAudience().then(res => {
      }).catch(err => {
      });
    } else if (selectTypeGridLs === SelectTypeGridEnum.Image) {
      doAudienceImageEmissora().then(res => {
      }).catch(err => {
      });
    }
  }
  function initilizeAudienceTimer() {
    // Limpa timer anterior se existir
    if (autoUpdateTimerRef.current) {
      clearInterval(autoUpdateTimerRef.current);
      autoUpdateTimerRef.current = null;
    }

    if (user.userPreference?.ChangeAutoUpdate) {
      autoUpdateTimerRef.current = setInterval(TimerAutoUpdate, 30000);
    }
  }

  function TimerAutoUpdate() {
    const userStorage = getUserPreferenceLocalStorage();
    if (userStorage?.autoUpdate) {
      loadAudience();
    }
  }

  const handleScroll = (e) => {
    let chartLine = document.querySelector("#chartLine");
    let tableGraphicPie = document.querySelector("#tableGraphicPie");
    let divMediaCompRight = document.querySelector("#divMediaCompRight");
    if (chartLine !== null)
      chartLine.scrollLeft = e.target.scrollLeft;
    if (tableGraphicPie !== null)
      tableGraphicPie.scrollLeft = e.target.scrollLeft;
    if (divMediaCompRight !== null)
      divMediaCompRight.scrollLeft = e.target.scrollLeft;

    const bottom = Math.abs(e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight)) <= 1;
    if (bottom && !hasLoadedAtBottom.current && !bottomCooldown.current) {
      hasLoadedAtBottom.current = true;
      changeBaseMinute(30);
      loadAudience();
      bottomCooldown.current = setTimeout(() => {
        bottomCooldown.current = null;
      }, 1000);
    } else if (!bottom) {
      hasLoadedAtBottom.current = false;
    }
  };
  function onSelectGridMinute() {
    onSelectGrid(true);
  }

  return (
    <div id="divMinuteComponent" data-testid="divMinuteComponent" style={{ width: '100%' }}>
      {showError ? <MinuteErrorMessage setShowError={setShowError} infoError={infoError} /> : ''}

      <MinuteTable
        audience={audience}
        audienceFirstTable={audienceFirstTable}
        heading={channels}
        handleScroll={handleScroll}
        lastAudience={lastAudience}
        data={lastThirtyAudience}
        dataPie={lastThirtyAudiencePie}
        onSelectGridMinute={onSelectGridMinute}
        selectTypeGrid={selectTypeGrid}
        changeSelectDiv={changeSelectDiv}
        DivMinute={DivMinute}
        DivChart={DivChart} />
      {(DivMinute === DivMinuteEnum.Minute || DivMinute === DivMinuteEnum.Image) && (
        <MinuteNetWorkMessage info={showInfo} infoText={infoSpan} audience={audience} />
      )}
    </div>
  );
}

export default Minute;